// extracted by css-extract-rspack-plugin
export default {"container":"container-Ivy_K_"};